module.exports = __webpack_public_path__ + "static/media/14alexiswknd.6fd14ea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/14alexiswknd.png
// module id = 113
// module chunks = 0